import { allDivisionsSortedByName } from '../../../graphql/custom_queries';
import PropTypes from 'prop-types';
import { generateClient } from "aws-amplify/api";
const client = generateClient();

const fetchDivisionsByAllSort = async (allSortValue) => {
  const response = await client.graphql({
    query: allDivisionsSortedByName,
    variables: {
      allSort: allSortValue,
      sortDirection: 'ASC'
    }
  });
  return response.data.allDivisionsSortableByName.items;
};

export const fetchAllDivisions = async (divisions) => {
  try {
    if (divisions) {
      // explicit override — single call as before
      const items = await fetchDivisionsByAllSort(divisions);
      return items.sort((a, b) => a.prettyname?.localeCompare(b.prettyname));
    }

    // default: merge "all" and "special"
    const [allItems, specialItems] = await Promise.all([
      fetchDivisionsByAllSort("all"),
      fetchDivisionsByAllSort("special"),
    ]);

    return [...allItems, ...specialItems]
      .sort((a, b) => a.prettyname?.localeCompare(b.prettyname));

  } catch (err) {
    console.error('error fetchAllDivisions: ', err);
    return [];
  }
};

fetchAllDivisions.propTypes = {
  divisions: PropTypes.string,
};